import React from 'react';
import { ArrowLeft } from 'lucide-react';

const PANTHERS_LOGO =
  'https://customer-assets.emergentagent.com/job_panthers-league/artifacts/h32tep3p_New%20Panthers%20Logo.jpg';

const AdminHeader = ({ onLogout }) => (
  <header className="admin-header">
    <div className="admin-header-content">
      <a href="/" className="back-link">
        <ArrowLeft size={20} />
        Back to Website
      </a>
      <div className="admin-title-section">
        <img src={PANTHERS_LOGO} alt="Panthers Logo" className="admin-logo" />
        <div>
          <h1 className="admin-title">Admin Dashboard</h1>
          <p className="admin-subtitle">Randallstown Youth Football & Cheer</p>
        </div>
      </div>
      <button onClick={onLogout} className="logout-btn">Logout</button>
    </div>
  </header>
);

export default AdminHeader;
